<div *ngIf="isVisible" [class.pass-scan-verwaltung--embedded]="embedded">
    <div class="one-row pass-scan-verwaltung__toolbar" *ngIf="!embedded">
        <h3>{{ gruppe?.bezeichnung }}</h3>
        <span class="spacer"></span>
        <button (click)="importScans()" color="accent" mat-flat-button>Scans importieren</button>
        <button (click)="refresh()" color="accent" mat-icon-button aria-label="Pass-PDFs aktualisieren">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>

    <div class="one-row pass-scan-verwaltung__toolbar pass-scan-verwaltung__toolbar--embedded" *ngIf="embedded">
        <h3 class="pass-scan-verwaltung__embedded-title">Pass-PDFs dieser Einstallung</h3>
        <span class="spacer"></span>
        <button
            type="button"
            mat-stroked-button
            color="accent"
            data-cy="einstallen-pass-pdf-show-all"
            (click)="openAllPassPdfsDialog()"
        >
            Alle Pass-PDFs
        </button>
        <button (click)="refresh()" color="accent" mat-icon-button aria-label="Pass-PDFs aktualisieren">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>

    <div
        *ngIf="!scans"
        class="pass-scan-verwaltung__state"
        [class.pass-scan-verwaltung__state--embedded]="embedded"
    >
        <mat-hint>Lade PDF-Dateien...</mat-hint>
    </div>

    <div
        *ngIf="scans?.length === 0"
        class="pass-scan-verwaltung__state"
        [class.pass-scan-verwaltung__state--embedded]="embedded"
    >
        <mat-hint>Noch keine PDFs hochgeladen...</mat-hint>
    </div>

    <div class="pass-scan-verwaltung__embedded-list" *ngIf="embedded && scans?.length > 0">
        <article class="pass-scan-verwaltung__card" *ngFor="let scan of scans" data-cy="einstallen-pass-pdf-card">
            <div class="pass-scan-verwaltung__card-head">
                <mat-icon
                    class="pass-scan-verwaltung__card-status"
                    [ngClass]="scanDone(scan) ? 'done' : 'pending'"
                    [matTooltip]="getStatusTooltip(scan)"
                >
                    {{ getStatusIcon(scan) }}
                </mat-icon>
                <div class="pass-scan-verwaltung__card-title-wrap">
                    <div class="pass-scan-verwaltung__card-title">{{ scan.dateiname }}</div>
                    <div class="pass-scan-verwaltung__card-meta">
                        {{ getPagesText(scan) }} Ohrmarken
                        <span *ngIf="!scanDone(scan)">· in Arbeit</span>
                    </div>
                </div>
            </div>
            <div class="pass-scan-verwaltung__card-details">
                <div *ngIf="scan.bemerkung">{{ scan.bemerkung }}</div>
                <div>{{ getStatusText(scan) }}</div>
                <div *ngIf="getJobProgressText(scan) !== '—'">Fortschritt: {{ getJobProgressText(scan) }}</div>
            </div>
            <div class="pass-scan-verwaltung__card-actions">
                <button mat-icon-button (click)="openPdfDialog(scan)" [matTooltip]="getDownloadTooltip(scan)">
                    <mat-icon>download</mat-icon>
                </button>
                <button
                    *ngIf="scan?.seitenzahl_fehler"
                    mat-icon-button
                    (click)="fehlerhafteSeitenNachtragen(scan)"
                    matTooltip="Fehlerhafte Seiten nachtragen"
                >
                    <mat-icon>edit_note</mat-icon>
                </button>
                <button
                    *ngIf="restartAllowed(scan)"
                    mat-icon-button
                    (click)="restart(scan)"
                    matTooltip="Neustart"
                    [disabled]="isSaving"
                >
                    <mat-icon>restart_alt</mat-icon>
                </button>
                <button *kienePermission="[9364]" (click)="deleteScan(scan)" mat-icon-button matTooltip="Löschen">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </article>
    </div>

    <div class="pass-scan-verwaltung__table-wrap" *ngIf="!embedded">
        <table *ngIf="scans?.length > 0" aria-label="" style="width: 100%">
            <thead>
                <th class="centered">Status</th>
                <th *ngIf="lss.isCurrentUserPhitoUser()">Grps Id</th>
                <th>Dateiname</th>
                <th>Bemerkung</th>
                <th>Viehh&auml;ndler</th>
                <th>Betriebskontakt</th>
                <th>Einstalldatum</th>
                <th>Status Text</th>
                <th>Aktueller Job</th>
                <th class="centered">%</th>
                <th class="centered">Ohrmarken verifiziert</th>
                <th class="centered">fehlerhafte Seiten</th>
                <th>erstellt</th>
                <th></th>
                <th></th>
                <th></th>
            </thead>
            <tbody>
                <tr *ngFor="let scan of scans">
                    <td [ngClass]="scanDone(scan) ? 'done' : 'pending'" class="centered">
                        <mat-icon [matTooltip]="getStatusTooltip(scan)">{{ getStatusIcon(scan) }}</mat-icon>
                    </td>
                    <td *ngIf="lss.isCurrentUserPhitoUser()">{{ scan.grps_id }}</td>
                    <td>{{ scan.dateiname }}</td>
                    <td>{{ scan.bemerkung }}</td>
                    <td>{{ scan.viehhaendler || "---" }}</td>
                    <td>{{ scan.betriebskontakt || "---" }}</td>
                    <td>{{ getEinstalldatumText(scan) | date: "dd.MM.YY" }}</td>
                    <td>{{ getJobDetailsText(scan) }}</td>
                    <td>{{ getStatusText(scan) }}</td>
                    <td class="centered">{{ getJobProgressText(scan) }}</td>
                    <td class="centered">
                        {{ getPagesText(scan) }}
                        &nbsp;{{ scanDone(scan) ? "" : "(in Arbeit)" }}
                    </td>
                    <td class="centered">
                        <div
                            (click)="$event.stopPropagation(); fehlerhafteSeitenNachtragen(scan)"
                            *ngIf="scan?.seitenzahl_fehler"
                            class="one-row fehlerhafte-seiten"
                            matTooltip="Ohrmarken von fehlerhaften Scans manuell nachtragen"
                        >
                            <span class="spacer"></span>
                            <span>{{ scan.seitenzahl_fehler }}</span>
                            <mat-icon>open_in_new</mat-icon>
                            <span class="spacer"></span>
                        </div>
                        <span *ngIf="!scan.seitenzahl_fehler">---</span>
                    </td>
                    <td>{{ scan.erstellt | date: "dd.MM.YY" }}</td>
                    <td>
                        <button mat-icon-button (click)="openPdfDialog(scan)" [matTooltip]="getDownloadTooltip(scan)">
                            <mat-icon>download</mat-icon>
                        </button>
                    </td>
                    <td>
                        <button *kienePermission="[9364]" (click)="deleteScan(scan)" mat-icon-button>
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                    <td *ngIf="restartAllowed(scan)">
                        <button mat-icon-button (click)="restart(scan)" matTooltip="Neustart" [disabled]="isSaving">
                            <mat-icon>restart_alt</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
